import {Component, inject, ChangeDetectionStrategy} from '@angular/core';
import {CommonModule} from '@angular/common';
import {ReactiveFormsModule, Validators} from '@angular/forms';
import {FormControl, FormGroup} from '@ng-stack/forms';
import {VwuiAngularModule, VwuiModalConfig, VwuiModalRef} from '@bvgo-ict/vwui-angular';
import {TranslatePipe} from '@ngx-translate/core';

import {ProjectDetails} from '../../models';
import {ProjectVersionBumpKind} from "../../utils/question-answer.util";


export interface NewProjectVersionModalData {
    project: ProjectDetails;
    currentVersion: string | null;
}

export interface NewProjectVersionModalResult {
    bumpKind: ProjectVersionBumpKind;
    note: string | null;
}

@Component({
    selector: 'app-new-project-version-modal',
    templateUrl: './new-project-version-modal.component.html',
    styleUrls: ['./new-project-version-modal.component.scss'],
    standalone: true,
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [CommonModule, ReactiveFormsModule, TranslatePipe, VwuiAngularModule]
})
export class NewProjectVersionModalComponent {
    public readonly modalRef = inject(VwuiModalRef);
    public readonly modalConfig = inject<VwuiModalConfig<NewProjectVersionModalData>>(VwuiModalConfig);

    public readonly form = new FormGroup({
        bumpKind: new FormControl<ProjectVersionBumpKind>('minor', Validators.required),
        note: new FormControl<string | null>(null)
    });

    public readonly currentVersion: string | null;
    public readonly isMajorAllowed: boolean;

    constructor() {
        const {project, currentVersion} = this.modalConfig.data;
        this.currentVersion = currentVersion;
        this.isMajorAllowed = project.isQuickscanFinalised();

        if (!currentVersion && this.isMajorAllowed) {
            this.form.patchValue({note: 'Projectintake ingediend'});
        }
    }

    public submit(): void {
        if (!this.form.valid) {
            this.form.markAllAsTouched();
            return;
        }

        const result: NewProjectVersionModalResult = {
            bumpKind: this.form.value.bumpKind,
            note: this.form.value.note?.trim() || null
        };

        this.modalRef.close(result);
    }
}
